export { default as UserManagement } from './UserManagement';


// WEBPACK FOOTER //
// ./src/features/user-management/index.js